module.exports = __webpack_public_path__ + "665828bd.svg";